const mutations = {
  getProjectId (state, payload) {  // state是个形参 是state对象里面的数据都可以拿到 不通过this来拿
    window.localStorage.setItem('projectId', payload.projectId)
    state.projectId = payload.projectId
  },
  getProjectName (state, payload) {
    window.localStorage.setItem('projectName', payload.projectName)
    state.projectName = payload.projectName
  },
  getCurrent (state, payload) {
    window.localStorage.setItem('dataCurrent', payload.dataCurrent)
    state.dataCurrent = payload.dataCurrent
  },
  setLoginStatus (state, payload) {
    state.isLogin = payload.status
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js